import { Component, input } from '@angular/core';
import { IconComponent } from '@components';

@Component({
  selector: 'app-validity-icon',
  imports: [IconComponent],
  templateUrl: './validity-icon.component.html',
  styleUrl: './validity-icon.component.scss',
})
export class ValidityIconComponent {
  readonly valid = input(false);
}
